define('ApiRequest',['jquery','underscore','app','router','challengeJs'], function ($,_,app,router, challengeJs) {

    return function(type,data,urlOptions,options){

        urlOptions = _.defaults(urlOptions||{},{
            iso_lang:app.isoLang()
        });
        var url = router.getApiRouteUrl('api'+type)(urlOptions);

        // ajax overrides options
        var o = _.defaults(options||{},{
            url:url,
            method:'POST',
            dataType:'json',
            data:data
        });

        return challengeJs(o);
    }

});
